import { useCallback, useLayoutEffect, useState } from "react"

export const useObserveElementRect = ({
    element: externalElement,
    observePosition = false,
}: { element?: HTMLElement | null; observePosition?: boolean } = {}) => {
    const [rect, setRect] = useState({ width: 0, height: 0, top: 0, left: 0 })
    const [internalElement, setInternalElement] = useState<HTMLElement | null>(null)

    const ref = useCallback((el: HTMLElement | null) => setInternalElement(el), [])

    const element = externalElement !== undefined ? externalElement : internalElement

    useLayoutEffect(() => {
        if (!element) return
        const updateRect = () => {
            const { width, height, top, left } = element.getBoundingClientRect()
            setRect((prev) =>
                prev.width === width &&
                prev.height === height &&
                prev.top === top &&
                prev.left === left
                    ? prev
                    : { width, height, top, left }
            )
        }
        if (observePosition) {
            let frameId = 0
            const trackFrame = () => {
                updateRect()
                frameId = requestAnimationFrame(trackFrame)
            }
            trackFrame()
            return () => cancelAnimationFrame(frameId)
        }
        const observer = new ResizeObserver(updateRect)
        observer.observe(element)
        return () => observer.disconnect()
    }, [element, observePosition])

    return { ref, ...rect }
}
